import { Injectable } from '@angular/core';
// import { version as appVersion } from '../../package.json';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor() {}

  clearCacheOnVersionChange(): void {
    // console.log(`App version: ${appVersion}`);

    // const storedAppVersion = localStorage.getItem('appVersion');

    // if (storedAppVersion !== appVersion) {
    //   console.log(`App version in cache: ${storedAppVersion}`);
    //   console.log('Clearing cache.');
    //   localStorage.clear();

    //   localStorage.setItem('appVersion', appVersion);
    // } else {
    //   console.log('Keeping cache.');
    // }
  }
}
